import { useEffect, useRef } from "react";
import { logPresence } from "../utils/presence";

const HEARTBEAT_MS = 60 * 60 * 1000; // 1 hour

// Pings `userActivity` on mount and every hour while the tab is visible.
// Pauses on `visibilitychange` (hidden tab = 0 writes), and re-pings when
// the tab becomes visible again so a returning user is counted in the
// current hour bucket.
export function usePresence({ user, userInfo, venueId }) {
  const venueIdRef = useRef(venueId);
  venueIdRef.current = venueId;

  const userRef = useRef(user);
  userRef.current = user;
  const userInfoRef = useRef(userInfo);
  userInfoRef.current = userInfo;

  useEffect(() => {
    if (!user?.uid) return;
    if (userInfo?.role === "admin") return;

    const ping = () =>
      logPresence({
        user: userRef.current,
        userInfo: userInfoRef.current,
        venueId: venueIdRef.current,
      });

    // Initial ping on mount/auth-ready.
    if (typeof document === "undefined" || !document.hidden) ping();

    let intervalId = window.setInterval(() => {
      if (!document.hidden) ping();
    }, HEARTBEAT_MS);

    const onVisibility = () => {
      if (!document.hidden) ping();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [user?.uid, userInfo?.role]);
}
